<div class="p-16" [ngClass]="sale ? 'qr-shadow' : ''">
    <app-send-givi-sms [sale]="sale" (sendLink)="onSendLink()"></app-send-givi-sms>
</div>


<ng-template #sendGiviModal let-modal>
    <div class="modal-body" style="background-color: white; border-radius: 15px;">
        <app-send-givi-link [sale]="sale"></app-send-givi-link>

        <div class="d-flex-center p-b-24 m-t-10">
            <a class="font-14 text-muted" (click)="onClose()">VOLVER</a>
        </div>
    </div>
</ng-template>